import { useEffect } from "react";
import { openCta, APPLICATIONS_CLOSED } from "../lib/penaltyRecoveryApi";

/**
 * Wire every [data-pr-cta] element inside `ref` to the tracked app.kgob.com
 * handover redirect. Used by the landing AND the legal pages (both render the
 * design's static markup, which includes funnel CTA buttons with href="#").
 *
 * APPLICATIONS CLOSED: "review" (checkout) CTAs are relabeled and openCta routes
 * them to the on-page contact form instead of app.kgob.com's checkout.
 */
export default function useCtaWiring(ref, source = "landing") {
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const handlers = [];
    root.querySelectorAll("[data-pr-cta]").forEach((el) => {
      const target = el.getAttribute("data-pr-cta");
      if (APPLICATIONS_CLOSED && target === "review") {
        el.textContent = "Applications Closed — Contact Us";
        el.setAttribute("data-testid", "pr-cta-closed");
      }
      const onClick = (e) => {
        e.preventDefault();
        openCta(target, source);
      };
      el.addEventListener("click", onClick);
      handlers.push([el, onClick]);
    });
    return () => handlers.forEach(([el, fn]) => el.removeEventListener("click", fn));
  }, [ref, source]);
}
